import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 0C0.447715 0 0 0.447716 0 1V13C0 13.5523 0.447715 14 1 14H2C2.55228 14 3 13.5523 3 13V1C3 0.447715 2.55228 0 2 0H1ZM10 0C9.44772 0 9 0.447716 9 1V13C9 13.5523 9.44771 14 10 14H11C11.5523 14 12 13.5523 12 13V1C12 0.447715 11.5523 0 11 0H10Z"
	})
});
export default SvgPause;
